<template>

<div>

<!-- .. NOTIFICATION  -->
<b-notification :closable="false" v-if="!localSelectedContact" style="padding: 20px;margin: 10px;">
    No Contacts selected!
    <!-- <b-loading :is-full-page="true" :active.sync="!localSelectedContact" :can-cancel="true"></b-loading> -->
</b-notification>

<div v-if="localSelectedContact">

  <section class="section">

    <!-- <b-field label="Gender" label-position="on-border">
      <b-select placeholder="Select Type" expanded v-model="selectedContact.gender" 
            @keypress.prevent icon="arrow-circle-right" icon-pack="fas">
        <option value="male ">Mr.</option>
        <option value="female">Mrs.</option>
        <option value="none">None</option>
      </b-select>
    </b-field>   -->
    <!-- <div style="min-height: 2em;"/> -->


    
    <h1><b>Contact</b></h1>

    <b-field label="Firstname" label-position="on-border">
        <b-input type="text" placeholder="Firstname"  
            v-model="localSelectedContact.firstname"
            maxlength="30">
        </b-input>
    </b-field>

    <b-field label="Name" label-position="on-border">
        <b-input type="text" placeholder="Name"  
            v-model="localSelectedContact.name"
            maxlength="30">
        </b-input>
    </b-field>

    <b-field label="DisplayName" label-position="on-border">
        <b-input type="text" placeholder="Name"  
            v-model="localSelectedContact.displayName"
            maxlength="50">
        </b-input>
    </b-field>

  </section>

  <!-- DATE SELECT -->
  <section class="section">

    <h1><b>Dátum posledného kontaktu</b></h1>

    <!-- <DateSelectorGroup 
    :pickeddate="this.localSelectedContact.status.lastcontact" 
    v-model="this.localSelectedContact.status.lastcontact"
    /> -->


    <!-- v-on:setdate="(e) => this.localSelectedContact.status.lastcontact = e" -->
    <!-- v-on:pickeddate="function(val) {this.localSelectedContact.status.lastcontact = val}" -->

    <!-- > here > {{this.localSelectedContact.status.lastcontact}} -->

    <b-field>
      <!-- v-if="localSelectedContact.status.lastcontact.length > 0" -->
      <!-- @input="onDateChanged" -->
      <b-datepicker 
          ref="datepicker"
          expanded
          placeholder="Select a date" 
          v-model="tmpdate"
          :date-parser="dateParser"
        >
          <!-- <button class="button is-primary " 
            @click="onDateChanged">
            <b-icon icon="calendar-today"></b-icon>
            <span>Set</span>
          </button> -->
      </b-datepicker>
      <b-button
          @click="$refs.datepicker.toggle()"
          icon-left="fas fa-calendar-alt"
          type="is-secondary" />
      <b-button
          @click="onDateChanged"
          icon-left="fas fa-save"
          type="is-secondary">
        SET 
      </b-button>

    </b-field>

    <b-field label="Last Contact"
        
        custom-class="has-text-success"
        type="is-success"
        message="contact date set">
        <!-- {{localSelectedContact.status.lastcontact | moment("dddd, MMMM Do YYYY") }} -->
        <b-input type="email"
          disabled
          placeholder="NO CONTACT DATE SAVED YET!"
          :value='localSelectedContact.status.lastcontact | moment("DD/MM/YYYY")'
          maxlength="30">
        </b-input>
    </b-field>

    <!-- <DateSelector v-model="localSelectedContact.status.lastcontact"  :initialDate="localSelectedContact.status.lastcontact" @lastcontactSelected="onDateSelected"/> -->
    <!-- <DateSelector v-model="selectedContact.status.lastcontact"  :initialDate="selectedContact.status.lastcontact" @lastcontactSelected="onDateSelected"/> -->

    <!-- {{moment(localSelectedContact.status.lastcontact, "YYY-MM-DDTHH:mm:ssZ").toDate() }} -->

    <!-- moment > {{ new Date() | moment("YYYY") }} -->
    <!-- <span>{{ localSelectedContact.status.lastcontact | moment("dddd, MMMM Do YYYY") }}</span> -->
    <!-- <span>{{ localSelectedContact.status.lastcontact }}</span> -->
  </section>
  
  <!-- <div class="column">

    <div class="column"> -->

  <section class="section">

      <b-field label="Customer Spending"/>

      <b-field>
        <!-- Total value: {{localSelectedContact.status.custtotal}}" € -->
        
      
        <!-- <b-field label="Add Value" label-position="on-border">
          <b-input type="number" v-model="addvalue" />
        </b-field> -->
      
        <b-field>
          <b-button
              @click="toggleOpenPurchase"
              icon-left="fas fa-plus"
              type="is-primary">
            Add 
          </b-button>
          <!-- <div style="min-width:20px:"/> -->
          
          <b-field type="is-primary" label="Total Amount" label-position="on-border" expanded>
            <b-input  type="number" v-model="localSelectedContact.status.custtotal" disabled expanded/>
          </b-field>
          <p class="control">
              <button class="button is-secondary">€</button>
          </p>

          <b-button
              @click="$router.push('/main/purchase')"
              icon-left="fas fa-search"
              type="is-secondary">
            All 
          </b-button>
        </b-field>

        <!-- <b-field label="Total Value" label-position="on-border" >
          <b-input type="number" v-model="localSelectedContact.status.custtotal" disabled expanded/>
        </b-field> -->

        <!-- ..PURCHASE -->
        </b-field>
          <div v-if="togglepurchase">
            <b-field label="Product/Service" label-position="on-border">
              <b-input type="text" placeholder="Enter purchase item"  
                  v-model="purchase.item"
                  maxlength="80">
              </b-input>
            </b-field>

            <b-field label="Comment" label-position="on-border">
                <b-input type="text" placeholder="Enter purchase comment"  
                    v-model="purchase.comment"
                    maxlength="80">
                </b-input>
              </b-field>

            <b-field>
              
              <b-field label="Purchase Value" label-position="on-border">
                <b-input type="number" v-model="purchase.amount" />
              </b-field>
              <p class="control">
                  <button class="button is-secondary">€</button>
              </p>
              <b-button
                  @click="savePurchase(purchase)"
                  icon-left="fas fa-plus"
                  type="is-secondary">
                Add 
              </b-button>
            </b-field>

          </div>
        <b-field>


      </b-field>
  </section> 
 
    <!-- .. SET CUST CLASS -->
    <section  class="section">
      <b-field>
      <!-- <div class="columns is-gapless"> -->
      <div class="columns ">
        
        <!-- <div class="column is-two-thirds"> -->
        <div class="column is-half">

          <b-field label="Customer Value">
            <b-select v-model="localSelectedContact.status.custvalue" @input="setCustClassGlobal" expanded>  
              <option value="">Select Value</option>
              <option v-for="value in custvalueSelectorvalues"
                      :value="value.id" v-bind:key="value.id">
                {{ value.name }} 
              </option>
            </b-select>
          </b-field>

          <b-field label="Customer Relations" >
            <b-select v-model="localSelectedContact.status.custrel" @input="setCustClassGlobal" expanded>  
              <option value="">Select Relation</option>
              <option v-for="value in custrelationSelectorvalues"
                      :value="value.id" v-bind:key="value.id">
                {{ value.name }} 
              </option>
            </b-select>
          </b-field>
        </div>

        <div class="column">

          <div style="min-height: 3em"/>

          <b-field v-if="!localSelectedContact.status.custclass">
            NOT SET
          </b-field>
      
          <b-field class="" style="padding: 0em; font-size:1.4em; text-align: center; margin-left: auto; margin-right: auto;">
                <!-- <div class="panel-icon" style="padding: 0em; font-size:1.4em; text-align: center; margin-left: auto; margin-right: auto;"> -->
                  <span v-if="localSelectedContact.status.custclass === 4" class="is-center" style="color: gold;" >GOLD</span>
                  <span v-if="localSelectedContact.status.custclass === 3" class="is-center" style="color: silver;" >SILVER</span>
                  <span v-if="localSelectedContact.status.custclass === 2" class="is-center" style="color: orange;" >BRONCE</span>
                  <span v-if="localSelectedContact.status.custclass === 1" class="is-center" style="color: black;" >POTATO</span>
                <!-- </div> -->
          </b-field>

          <b-field class="is-center"  style="padding: 0em; font-size:2.8em; text-align: center; margin-left: auto; margin-right: auto;">
                <!-- <span class="panel-icon" style="padding-left: 0em; font-size:2.8em;"> -->
                  <i v-if="localSelectedContact.status.custclass === 4" class="fas fa-trophy" style="color: gold;" aria-hidden="true"></i>
                  <i v-if="localSelectedContact.status.custclass === 3" class="fas fa-trophy" style="color: silver;" aria-hidden="true"></i>
                  <i v-if="localSelectedContact.status.custclass === 2" class="fas fa-trophy" style="color: orange;" aria-hidden="true"></i>
                  <i v-if="localSelectedContact.status.custclass === 1" class="fas fa-trophy" style="color: black;" aria-hidden="true"></i>
                <!-- </span> -->
          </b-field>

        </div>
      </div>
      </b-field>
    </section>

    <section class="section">
      <b-field label="Add some tags">
          <b-taginput
              v-model="localSelectedContact.status.tags"
              ellipsis
              icon="label"
              placeholder="Add a tag">
          </b-taginput>
      </b-field>
      <!-- <p class="content"><b>Tags:</b> {{ localSelectedContact.status.tags }}</p> -->
    
      <br>
      <b>Predefined Tags:</b> <small>  [click to add]  </small>
      <br>

      <!-- {{ getAccount.ctags }} -->
      <b-field grouped group-multiline>
        <div v-for="tag in getAccount.ctags" :key="tag">
          <div @click="addPreTag(tag)" style="margin:0.2em; padding:0.2em; min-width: 3em; background: green; color: white;">{{tag}}</div>
        </div>
      </b-field>
    
      <br>
    
    
    </section>




    <div style="margin-top:10px;">
      <a class="button is-light"  @click="saveContact">
        <div>  
          <i class="fas fa-save" style="color: green; margin-right: 1em; font-size:1.8em;" aria-hidden="true"></i>
        </div>
        SAVE
      </a>
    </div>  
    <!-- <div class="buttons">
      <a class="button is-light"  @click="saveNewContact">
      <div>  
        <i class="fas fa-save" style="color: green; margin-right: 1em; font-size:1.8em;" aria-hidden="true"></i>
      </div>
      SAVE NEW CONTACT
    </a>
    </div> -->



</div>

</div>
</template>

<script>
// import Calendar from '@/components/main/contact/Calendar.vue';
// import DateSelector from '@/components/tools/DateSelector.vue';
// import DateSelectorGroup from '@/components/tools/DateSelectorGroup.vue';
import { mapGetters, mapActions } from 'vuex';
import { PurchaseStruct } from '@/utils/structs';

export default {

  name: 'Classification',
  components: {
    // DateSelector,
    // DateSelectorGroup
  },
  props: [
    // msg: String,
    // 'classification'
    'localSelectedContact'
  ],
  data() {
    return  {
      
      // addvalue: 10,
      purchase: PurchaseStruct,
      // purchase: {amount: 10, item: '', comment: ''},
      // purchasevalue: 10,
      // purchaseitem: '',
      // purchasecomment: '',
      togglepurchase: false,
      // localSelectedContact: null,
      // lastcontact: new Date(), //null, // new Date(), //..test
      tmpdate: new Date(),

      custvalueSelectorvalues: [],
      custrelationSelectorvalues: [],
      custclassSelectorvalues: [],

      
    }
  },
  created () {
    // this.localvalues = {custtotal: 0, custvalue: '', custrel: '', custclass:'', lastcontact: '', tags: []},
    this.custvalueSelectorvalues = [
      {id: 1, name: "€"},
      {id: 2, name: "€€"},
      {id: 3, name: "€€€"},
    ],
    this.custrelationSelectorvalues = [
      {id: 1, name: ":-("},
      {id: 2, name: ":-|"},
      {id: 3, name: ":-)"},
      
    ],
    this.custclassSelectorvalues = [
      {id: 4, name: "gold"},
      {id: 3, name: "silver"},
      {id: 2, name: "bronce"},
      {id: 1, name: "kartoffel"},

    ]
    // this.localSelectedContact = this.selectedContact,
    // this.localSelectedContact = JSON.parse(JSON.stringify(this.selectedContact)),

  },
  computed: {
    ...mapGetters(['getProfile', 'getAccount']), //'selectedContact'
  },
  methods: {
    ...mapActions(['updateContact','putSelectedContact', 'addNewPurchase']), //'addNewContact'
    dateParser(date) {
      new Date.parse(date);
      // if (date.length>0) {
      //   new Date.parse(date);
      // } else {
      //   new Date()
      // }
    },
    onDateChanged () { //..without component
      // console.log("emit ... " + date);
      this.localSelectedContact.status.lastcontact = this.tmpdate
    },
    // onChange () {
    //   this.$emit('input', this.selectedContact)
    // },
    onDateSelected (date) {
      // console.log('received: '+date);
      this.localSelectedContact.status.lastcontact = date;
      // this.classification.lastcontact = date;
    },
    toggleOpenPurchase () {
      // console.log(value)
      // console.log(parseInt(value))
      // this.localSelectedContact.status.custtotal += parseInt(value)
      this.togglepurchase = !this.togglepurchase
      this.purchasetext = ''    //default
      this.purchasevalue = 10   //default
    },
    savePurchase (purchase) {
      this.localSelectedContact.status.custtotal += parseInt(purchase.amount)
      console.log("TODO .. persist purchase > "+purchase.amount + " | "+purchase.item + " | "+purchase.comment)
      let newpurchase = {id: '1', pdate: new Date(), 
              amount: purchase.amount, item: purchase.item, comment: purchase.comment, 
              contactid: this.localSelectedContact.id, 
              userid: this.getProfile.id, accountid: '1',
              userdisplayname: this.getProfile.firstname + " " + this.getProfile.name,

          }
      this.addNewPurchase(newpurchase)

      this.togglepurchase = false;
    },

    setCustClassGlobal () {
  
      var tmpsum = this.localSelectedContact.status.custvalue + this.localSelectedContact.status.custrel
      var tmpclass = {}
     
      if (tmpsum>=6) tmpclass = this.custclassSelectorvalues[0].id; else
      if (tmpsum>=5) tmpclass = this.custclassSelectorvalues[1].id; else 
      if (tmpsum>=3) tmpclass = this.custclassSelectorvalues[2].id; else
      if (tmpsum>=0) tmpclass = this.custclassSelectorvalues[3].id;
      // this.selectedContact.status.custclass = tmpclass
      this.localSelectedContact.status.custclass = tmpclass

      // this.putSelectedContact(this.selectedContact)
    },
    addPreTag(tag) {
      if (!this.localSelectedContact.status.tags.includes(tag)) {
        this.localSelectedContact.status.tags.push(tag)
      }
      
    },
    // addContact () {
    //   this.localSelectedContact =
    //     {id:null, firstname: 'New Contact', name:'', channels: [],
    //           status: {custtotal: 0, custvalue: '', custrel: '', custclass: '', lastcontact: ''},
    //         }
    //   this.addNewContact(this.localSelectedContact)
    //   this.putSelectedContact(this.localSelectedContact)
    // },
    saveContact () {

      this.updateContact(this.localSelectedContact)
      this.putSelectedContact(this.localSelectedContact)
      // this.updateContact(this.selectedContact)  //..even here the original object can be used, but copying in the WATCH section is important for reactivty !!!??? (not sure why)
    },
    // saveNewContact () {
    //   this.localSelectedContact.id = (new Date()).getTime()
    //   this.addNewContact(this.localSelectedContact)
    // }
  },
  watch: {
    selectedContact(newValue) {
      // this.localSelectedContact = JSON.parse(JSON.stringify(newValue))
      // this.localSelectedContact = newValue
    },
    // getAccount() {},
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* .my-center-horizontal {
    display: block;
  } */

  .section {
    /* background: rgb(145, 184, 145); */
    /* background: #dbdbdb; */
    background: whitesmoke;
    padding: 10px;
    margin-top: 10px;
    margin-bottom:10px;
    
  }

  .section:hover {
    /* background-color: #4a4a4a; */
    background-color:rgb(145, 184, 145)
    /* color: white */
  }
  .label:hover {
    color: white;
  }

</style>